import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import NotificationWindow from 'components/NotificationWindow';
import { GLOBAL_MESSAGES } from 'utils/messages';

class ErrorNotificationPage extends Component {
  constructor(props) {
    super(props);

    this.onCloseNotification = this.onCloseNotification.bind(this);
  }

  onCloseNotification() {
    const { dispatch, redirectUrl } = this.props;

    dispatch(push(redirectUrl ? redirectUrl : '/'));
  }

  render() {
    const { notificationMessage } = this.props;

    if (notificationMessage) {
      let message = notificationMessage;

      if (GLOBAL_MESSAGES[message]) {
        message = GLOBAL_MESSAGES[message];
      }

      return (
        <NotificationWindow
          message={message}
          onClose={this.onCloseNotification}
        />
      );
    }

    return <>{this.props.children}</>;
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch
});

export default connect(null, mapDispatchToProps)(ErrorNotificationPage);

ErrorNotificationPage.propTypes = {
  notificationMessage: PropTypes.string,
  redirectUrl: PropTypes.string
};
